import React, { useContext, useEffect } from 'react'
import "./AllowAccessAndroid.css"
import { BrowserSetting, cameraAllow, cameraSetting, cameraToggle, microPhoneToggle } from '../../../images/btnIcons'
import { SpeakerContext } from '../../../context/SpeakerContext'
import { Button } from 'unified-ui-components-library'


const AllowAccessAndroid = ({startVideo}) => {
    const { handlebackBtnDisplay, handleAudioIconDisplay } = useContext(SpeakerContext)

    useEffect(()=>{
        handlebackBtnDisplay(true)
        handleAudioIconDisplay(false)
        return ()=>{
            handlebackBtnDisplay(false)
            handleAudioIconDisplay(true)
        }
    },[])

    return (
        <div className="allowAccessWrapper">
            <h5>Allow Camera & Microphone access</h5>
            <ol className='allowAccessList'>
                <li>
                    <h6>Open Browser Settings</h6>
                    <p> To the right of the address bar, tap More &gt; <span>Settings.</span></p>
                    <img className='imgStyle' src={BrowserSetting} alt="browser-setting-image" />
                </li>
                <li>
                    <h6>Tap Site Settings</h6>
                    <p> Tap Microphone or Camera</p>
                    <img className='imgStyle' src={cameraSetting} alt="browser-setting-image" />
                </li>
                <li>
                    <h6>Tap to turn the microphone or camera on or off</h6>
                    <img className='imgStyle' src={cameraToggle} alt="browser-setting-image" />
                    <img className='imgStyle' style={{ marginTop: "6px" }} src={microPhoneToggle} alt="browser-setting-image" />

                </li>
                <li>
                    <h6>If you see the site you want to use under Blocked, tap the site <span> Access your microphone &gt; Allow.</span></h6>
                    <img className='imgStyle' src={cameraAllow} alt="browser-setting-image" />
                </li>
            </ol>
            <div className="btnWrapper">
                <Button
                    buttonType='primary'
                    width="264"
                    onClick={startVideo}
                >
                    Next
                </Button>
            </div>
        </div>
    )
}

export default AllowAccessAndroid